import { resolveSystemProtocolUrl, systemProtocolArticlePath } from '~/utils/systemProtocols'

export default defineNuxtRouteMiddleware(to => {
  if (!['/v', '/v/', '/v/m', '/detail/pc'].includes(to.path)) return
  const raw = Array.isArray(to.query.url) ? to.query.url[0] : to.query.url
  const url = resolveSystemProtocolUrl(raw)
  // 旧书签和数据库低代码页脚继续可用，最终统一读取文章管理内容。
  if (url) return navigateTo(systemProtocolArticlePath(url), {replace: true, redirectCode: 301})
})
